/**
 * Tracking object structure that can have deep/quick variants
 */
export interface TrackingWithVariants {
  stepName?: string
  stepNumber?: number
  stepId?: string
  deepStepNumber?: number
  quickStepNumber?: number
  deepStepId?: string
  quickStepId?: string
  fieldName?: string
}

/**
 * Resolved tracking object with stepId and stepNumber set based on flow type
 */
export interface ResolvedTracking {
  stepName?: string
  stepId?: string
  stepNumber?: number
  fieldName?: string
}

/**
 * Resolves tracking stepId and stepNumber based on flow type (deep vs quick)
 * @param tracking - Tracking object with deep/quick variants
 * @param isDeepDive - Whether the current flow is deep dive
 * @param fallbackStepIndex - Optional fallback step index if stepId/stepNumber are not available
 * @returns Resolved tracking object with stepId and stepNumber set
 */
export function resolveTrackingValues(
  tracking: TrackingWithVariants | undefined,
  isDeepDive: boolean,
  fallbackStepIndex?: number,
): ResolvedTracking | undefined {
  if (!tracking) {
    return undefined
  }

  return {
    stepName: tracking.stepName,
    fieldName: tracking.fieldName,
    stepId: isDeepDive
      ? tracking.deepStepId
      : (tracking.quickStepId ??
        (fallbackStepIndex !== undefined ? `step-${fallbackStepIndex}` : undefined)),
    stepNumber: isDeepDive
      ? tracking.deepStepNumber
      : (tracking.quickStepNumber ?? fallbackStepIndex),
  }
}
